import { useState } from 'react'

const useShowMore = ({
  elements = [],
  initialElementsToShow = 10,
  paginated = false,
  hasNextPage,
  onLoadMore,
  totalCount,
}) => {
  const [numberOfElementsToShow, setNumberOfElementsToShow] = useState(initialElementsToShow)

  if (paginated) {
    return {
      elementsToShow: elements,
      hasMoreElements: !!hasNextPage,
      showMore: onLoadMore,
      totalElements: totalCount,
      numberOfElementsToShow: elements?.length,
    }
  }

  const elementsToShow = elements?.slice(0, numberOfElementsToShow) || []
  const hasMoreElements = elements?.length > numberOfElementsToShow

  const showMore = () => {
    setNumberOfElementsToShow(elements?.length)
  }

  return {
    elementsToShow,
    hasMoreElements,
    showMore,
    totalElements: elements?.length,
    numberOfElementsToShow,
  }
}

export default useShowMore
